import React, { useState } from 'react'

const Services = () => {
    const [content, setContent] = useState(<div className="screen">This service has not been enabled. contact support for further assistance.</div>)
    return (
        <div className='content services'>
            <div className="services-container">
                {content}
                <div className="selectors">
                    <div className="selector" onClick={() => setContent(<div className="screen">Stock Market services has not been enabled. contact support for further assistance.</div>)}>
                        Stock Market
                    </div>
                    <div className="selector" onClick={() => setContent(<div className="screen">Netflix service has not been enabled. contact support for further assistance.</div>)}>
                        Netflix
                    </div>
                    <div className="selector" onClick={() => setContent(<div className="screen">Loan service has not been enabled. contact support for further assistance.</div>)}>
                        Loan
                    </div>
                    <div className="selector" onClick={() => setContent(<div className="screen">Mortgage service has not been enabled. contact support for further assistance.</div>)}>
                        Mortgage
                    </div>
                    <div className="selector" onClick={() => setContent(<div className="screen">POS services has not been enabled. contact support for further assistance.</div>)}>
                        Point of Sale (POS)
                    </div>
                    <div className="selector" onClick={() => setContent(<div className="screen">Request for an online payment solution(s).</div>)}>
                        Online Payment System
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Services
